import { useGetConversationStatsQuery } from "@financial-advisory/data-access/financial-advisory-api-service";
import { CheckCircle2 } from "lucide-react";
import { LoadingMetricCard } from "./LoadingMetricCard";
import { MetricCard } from "./MetricCard";

export function ChatCompletionMetricCard() {
  const { data, isLoading, isFetching } = useGetConversationStatsQuery();

  if (isLoading || isFetching) {
    return <LoadingMetricCard label="Chat completion %" />;
  }

  return (
    <MetricCard
      icon={<CheckCircle2 className="w-4 h-4" />}
      value={`${data?.completion_percentage ?? 0}%`}
      label="Chat completion %"
      className="w-1/3"
    />
  );
}
